export const categories = [
  {
    slug: 'security-risks',
    name: '安全风险',
    description: '了解破解版应用可能带来的各种安全隐患，保护您的设备与数据安全',
    icon: 'ri-shield-flash-line',
  },
  {
    slug: 'usage-tutorials',
    name: '使用教程',
    description: '破解版软件的安装、使用及常见问题解决指南',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'alternatives',
    name: '替代方案',
    description: '推荐安全可靠的正版替代应用，告别破解版的种种风险',
    icon: 'ri-swap-line',
  },
  {
    slug: 'industry-news',
    name: '行业动态',
    description: '关注应用安全领域的最新趋势、政策变化与行业新闻',
    icon: 'ri-newspaper-line',
  },
];